import API from "@/interceptors/Api";
import type { CashPoolingRole } from "../types/role.types";

export const getRoleValues = async (): Promise<Record<CashPoolingRole, number>> => {
  const response = await API.get("/cash-pooling/roles/values");
  return response as unknown as Record<CashPoolingRole, number>;
};
